import { api_GET, api_POST, api_PUT } from "../api/_axios.js";

const documento_api =
{
    getAll: function (status = "") {
        const promise = new Promise((resolve, reject) => {
            api_GET(`documento/${status}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getItem: function (id) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`documento/getItem/${id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    post: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`documento`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    put: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`documento`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

}

export default documento_api
